import React, { useState, useEffect } from "react";
import { useAppContext } from "../../../State/Global/AppContext";
import { useTranslation } from "react-i18next";
import { List, Skeleton, Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faSms } from "@fortawesome/free-solid-svg-icons";
import {
    faWhatsapp,
    faFacebookMessenger,
    faInstagram,
    faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import ChatItemActions from "./ChatItemActions";
import styles from "./ChatItem.module.scss";
import CTA from "../../../Constants";
const {
    itemChatDescription,
    itemNew,
    itemDescription,
    instagramWrapper,
    itemDescriptionAssignation,
    itemDescriptionGroups,
} = styles;
function ChatItem({ chat, selected, openChatCb, optionsCb, handleModalCb, getChatDescriptionCb }) {
    const { t } = useTranslation();
    const [chatDescription, setChatDescription] = useState(null);
    const { appState } = useAppContext();
    function getCustomerTitle() {
        if (chat.customer?.fullName) {
            if (chat.customer?.extraData?.lastName) {
                return chat.customer.fullName + " " + chat.customer.extraData.lastName;
            }
            return chat.customer?.fullName;
        }
        if (chat.customer?.phone) {
            return chat.customer?.phone;
        }
        if (chat.customer?.email) {
            return chat.customer?.email;
        }
        return t("customerUnidentified");
    }

    function getCustomerDescription() {
        let groupTag;
        let moreGroupsTag;
        if (chat.groups && chat.groups.length) {
            groupTag = {
                color: null,
                value: chat.groups[0].name,
            };
            if (chat.groups.length > 1) {
                moreGroupsTag = {
                    color: null,
                    value: `+${chat.groups.length - 1}`,
                };
            }
        }

        let assignationTag;
        if (chat.status === CTA.FILTERS.ACTIVE) {
            if (chat.ownedBy) {
                assignationTag = {
                    color: "blue",
                    value: chat.ownedBy.email,
                };
            } else if (!chat.ownedByAgentType) {
                assignationTag = {
                    color: "red",
                    value: t("filters.unassigned"),
                };
            } else if (chat.ownedByAgentType?.includes("CHAT_BOT")) {
                assignationTag = {
                    color: "green",
                    value: t("filters.bot"),
                };
            }
        } else if (chat.status === CTA.FILTERS.ENDED) {
            assignationTag = {
                color: "gray",
                value: t("filters.isClosed"),
            };
        } else if (chat.status === CTA.FILTERS.INIT_BY_AGENT) {
            assignationTag = {
                color: "green",
                value: t("filters.init_by_agent"),
            };
        }



        return (
            <div className={itemDescription}>
                <div className={itemDescriptionAssignation}>
                    {assignationTag && (
                        <Tag color={assignationTag.color}>{assignationTag.value}</Tag>
                    )}

                    {chat.ownedBy?.id === appState.agent.id && chat.startedWaitingOn && (
                        <span className={itemNew}>{chat.amountNew > 0 ? chat.amountNew : ""}</span>
                    )}
                </div>

                {groupTag && (
                    <div className={itemDescriptionGroups}>
                        <Tag>{groupTag.value}</Tag>
                        {moreGroupsTag && <Tag>{moreGroupsTag.value}</Tag>}
                    </div>
                )}

                <span className={itemChatDescription}>{chatDescription}</span>
            </div>
        );
    }
    function getChannelIcon() {
        if (chat.customerChannel?.type === "WHATSAPP") {
            return (
                <FontAwesomeIcon style={{ color: "#25D366", fontSize: "25px" }} icon={faWhatsapp} />
            );
        }
        if (chat.customerChannel?.type === "FACEBOOK") {
            return (
                <FontAwesomeIcon
                    style={{ color: "#0078FF", fontSize: "25px" }}
                    icon={faFacebookMessenger}
                />
            );
        }
        if (chat.customerChannel?.type === "INSTAGRAM") {
            return (
                <div className={instagramWrapper}>
                    <FontAwesomeIcon icon={faInstagram} />
                </div>
            );
        }
        if (chat.customerChannel?.type === "SMS") {
            return <FontAwesomeIcon style={{ color: "#5c4ab2", fontSize: "25px" }} icon={faSms} />;
        }
        if (chat.customerChannel?.type === "FACEBOOK_COMMENT") {
            return (
                <FontAwesomeIcon style={{ color: "#0078FF", fontSize: "25px" }} icon={faFacebook} />
            );
        }
        return (
            <FontAwesomeIcon style={{ color: "#92D3FF", fontSize: "25px" }} icon={faCommentDots} />
        );
    }

    function handleOption(chat, owner, action) {
        optionsCb(chat, owner, action);
    }

    function handleAction(action) {
        if (action === "changeGroup") {
            handleModalCb(CTA.CHATS.OPTIONS.CHANGE_GROUP, chat);
        }
        if (action === "changeOwner") {
            handleModalCb(CTA.CHATS.OPTIONS.DERIVATE, chat);
        }
        if (action === "unassign") {
            handleOption(chat, CTA.CHATS.OPTIONS.UNASSIGNED, CTA.CHATS.OPTIONS.UNASSIGN);
        }
        if (action === "assign") {
            handleOption(chat, CTA.CHATS.OPTIONS.ME, CTA.CHATS.OPTIONS.ASSIGN);
        }
        if (action === "close") {
            handleOption(chat, chat.ownedBy, CTA.CHATS.OPTIONS.CLOSE);
        }
        if (action === "markRead") {
            handleOption(chat, chat.ownedBy, CTA.CHATS.OPTIONS.MARK_READ);
        }
        if (action === "markUnread") {
            handleOption(chat, chat.ownedBy, CTA.CHATS.OPTIONS.MARK_UNREAD);
        }
    }

    function getAssignStatus(currentChat) {
        if (currentChat.ownedBy) return "isAssigned";
        return "isUnassigned";
    }

    function getOwnerStatus(currentChat) {
        if (currentChat.ownedBy && currentChat.ownedBy.isCurrentUser) return "currentUserIsOwner";
        return "currentUserIsNotOwner";
    }

    function getAdminStatus(isAdmin) {
        return appState.agent?.isAdmin ? "currentUserIsAdmin" : "currentUserIsBasic";
    }

    useEffect(() => {
        setChatDescription(getChatDescriptionCb(chat));
        const interval = setInterval(() => {
            setChatDescription(getChatDescriptionCb(chat));
        }, 60000);
        return () => clearInterval(interval);
    }, [chat]);

    return (
        <List.Item
            style={{ backgroundColor: selected ? "rgb(232 232 232 / 65%)" : "inherit" }}
            onClick={() => openChatCb(chat)}
        >
            <List.Item.Meta
                avatar={getChannelIcon()}
                title={getCustomerTitle()}
                description={getCustomerDescription()}
            />

            <ChatItemActions
                chat={chat}
                assignStatus={getAssignStatus(chat)}
                ownerStatus={getOwnerStatus(chat)}
                adminStatus={getAdminStatus(chat)}
                actionCb={handleAction}
            />
        </List.Item>
    );
}
export default ChatItem;

export function ChatItemSkeleton() {
    return <Skeleton avatar active paragraph={{ rows: 1 }} />;
}